import { render, staticRenderFns } from "./SchoolPortraitActivityManage.vue?vue&type=template&id=0ffc3c61&scoped=true"
import script from "./SchoolPortraitActivityManage.vue?vue&type=script&lang=js"
export * from "./SchoolPortraitActivityManage.vue?vue&type=script&lang=js"
import style0 from "./SchoolPortraitActivityManage.vue?vue&type=style&index=0&id=0ffc3c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc3c61",
  null
  
)

export default component.exports